import React from 'react';
import { useUIState } from '../../contexts/UIStateProvider';
import { Modal } from '../../../../../../common/components/Modal/Modal';
import { DeviceSelect } from '../DeviceSelect/DeviceSelect';

export const DEVICE_MODAL = 'device';

export const DeviceSelectModal = () => {
	const { currentModals, closeModal, modalData } = useUIState();

	return (
		<Modal
			title={'Call settings'}
			open={!!currentModals[DEVICE_MODAL]}
			onClose={() => closeModal(DEVICE_MODAL)}
			PaperProps={{
				className: `modal--${DEVICE_MODAL}`, // found by UIStateProvider.autoOpenModal's fly-out
				sx: {
					width: `50vw !important`,
					minWidth: `50vw !important`,
				},
			}}
		>
			<DeviceSelect autoOpenSaveLevel={!!modalData?.[DEVICE_MODAL]?.autoOpenSaveLevel} />
		</Modal>
	);
};
